// Add your custom JS here.
jQuery(function ($) {

	$(document).ready(function() {


		$('div#kgfMoreStories .modal').on('show.bs.modal', function (e) {
		  const video = $(this).find('video').get(0);
		  if (video) {
		    video.play();
		  }
		});


		$('div#kgfMoreStories .modal').on('hide.bs.modal', function (e) {
		  const video = $(this).find('video').get(0);
		  if (video) {
		    video.pause();
		  }
		});


		function moveBannerText() {
        if ($(window).width() <= 1024) {
            // Move, wrap, and adjust classes
            $('.banner_text p').each(function() {
                var $this = $(this);
                if (!$this.hasClass('moved-mobile')) {
                    $this.removeClass('txt-white').addClass('txt-navy moved-mobile')
                        .wrap('<div class="container txt-navy mt-4"><div class="row"></div></div>')
                        .parent().parent().insertAfter('.banner');
                }
            });
        } else {
            // Unwrap, move back, and adjust classes
            $('.moved-mobile').each(function() {
                var $this = $(this);
                if ($this.closest('.container').length) {
                    $this.unwrap().unwrap(); // Remove the wrapping divs
                    $this.insertAfter('.banner_text h1').removeClass('moved-mobile txt-navy').addClass('txt-white');
                }
            });
        }
    }

    // Initial check
    moveBannerText();

    // Check on resize
    $(window).resize(function() {
        moveBannerText();
    });

		if ($('.team-wrapper .team-member-indiv').length > 4) {
	        $('.team-member-indiv').addClass('with-margin');
	    }

		$('.recent_blog .blog-post .entry-title').matchHeight();

		$('.recent_blog .blog-post .excerpt p').matchHeight();

		$('.page-id-40992 #ad-leadership-team .team-wrapper .team-member-indiv .headshot .title').matchHeight();

		    // Select all .row elements within .column-content-layout
				var $rows = $('.column-content-layout .row');

				// Iterate over each .row element
				$rows.each(function() {
				    // Find all .flex-column divs within the current .row
				    var $flexColumns = $(this).find('.flex-column');

				    // Check if there are exactly 4 .flex-column divs
				    if ($flexColumns.length === 4) {
				        // Add the class col-lg-3 to all of them
				        $flexColumns.addClass('col-lg-3');
				    }
				});



		      $('.alumni-spotlights .row .spotlight a').click(function() {
			        var title = $(this).data('title');
			        var content = $(this).data('content');
			        var gradYear = $(this).data('grad-year');

			        $('#postModalLabel').text(title);
			        $('#postModalContent').html('<p>' + content + '</p><p>Graduation Year: ' + gradYear + '</p>');
			    });

		if ($(window).width() >= 769) {
		    $(window).scroll(function() {
		        var scroll = $(window).scrollTop();
		        if (scroll > 50) {
		            $("#main-nav").addClass("navbar-scrolled");
		            $(".navbar-scrolled .container .navbar-brand img").attr("src", "/wp-content/uploads/2025/06/mv_royal_nothe.png");
		            $(".navbar-scrolled .container .navbar-brand img").attr("srcset", "/wp-content/uploads/2025/06/mv_royal_nothe.png 748w, /wp-content/uploads/2025/06/mv_royal_nothe.png 300w");
		            $(".navbar-royal .container .navbar-brand img").attr("src", "/wp-content/uploads/2025/06/mv_royal_nothe.png");
		            $(".navbar-royal .container .navbar-brand img").attr("srcset", "/wp-content/uploads/2025/06/mv_royal_nothe.png 748w, /wp-content/uploads/2025/06/mv_royal_nothe.png 300w");
		        } else {
		            $("#main-nav").removeClass("navbar-scrolled");
		            $(".container .navbar-brand img").attr("src", "/wp-content/uploads/2025/06/mv_white_nothe.png"); // Replace with the original logo source
		            $(".container .navbar-brand img").attr("srcset", "/wp-content/uploads/2025/06/mv_white_nothe.png 748w, /wp-content/uploads/2025/06/mv_white_nothe.png 300w");
		            $(".navbar-royal .container .navbar-brand img").attr("src", "/wp-content/uploads/2024/06/Royal_PrimaryLogo.png");
		            $(".navbar-royal .container .navbar-brand img").attr("srcset", "/wp-content/uploads/2024/06/Royal_PrimaryLogo.png 748w, /wp-content/uploads/2024/06/Royal_PrimaryLogo.png 300w");
		        } 
		    });
		}
		else {
	        $("#main-nav").addClass("navbar-scrolled");
	        $(".navbar-scrolled .container .navbar-brand img").attr("src", "/wp-content/uploads/2025/06/mv_royal_nothe.png");
	        $(".navbar-scrolled .container .navbar-brand img").attr("srcset", "/wp-content/uploads/2025/06/mv_royal_nothe.png 748w, /wp-content/uploads/2025/06/mv_royal_nothe.png 300w");
	        $(".navbar-royal .container .navbar-brand img").attr("src", "/wp-content/uploads/2025/06/mv_royal_nothe.png");
	        $(".navbar-royal .container .navbar-brand img").attr("srcset", "/wp-content/uploads/2025/06/mv_royal_nothe.png 748w, /wp-content/uploads/2025/06/mv_royal_nothe.png 300w");
	    }



  		if( $(".banner").hasClass( "white-shape" ) ){
		  $( "nav.navbar" ).addClass( "navbar-royal" );
		}

	// Function to calculate card width and height
    function calculateCardSize() {
        var containerWidth = $(".demo-card-wrapper").width();
        var cardWidth = (containerWidth - 30) / 2; // Subtracting margins
        var cardHeight = 400; // Assuming fixed height for all cards
        $(".demo-card").css({"width": cardWidth, "height": cardHeight});
    }

    // Call the function on page load and window resize
    $(window).on("load resize", function(){
        calculateCardSize();
    });


	});

if (
    $(".banner").hasClass("photo") || 
    $(".banner").hasClass("video") || 
    $(".error404 .content-block").hasClass("bg-photo") || 
    $(".page-id-42788 .content-block").hasClass("bg-photo") || 
    $("body").hasClass("page-id-43172") || 
    $("body").hasClass("page-id-43766") || 
    $("body").hasClass("page-id-44102") || 
    $("body").hasClass("page-id-43776") || 
    $("body").hasClass("page-id-44049") || 
    $("body").hasClass("page-id-44043") || 
    $("body").hasClass("page-id-45020") || 
    $("body").hasClass("page-id-45031")
) {
    $("nav .container .navbar-brand img").attr({
        'src': '/wp-content/uploads/2025/06/mv_white_nothe.png',
        'srcset': '/wp-content/uploads/2025/06/mv_white_nothe.png 748w, /wp-content/uploads/2025/06/mv_white_nothe.png 300w'
    });
    $("nav.navbar-scrolled .container .navbar-brand img").attr({
        'src': '/wp-content/uploads/2025/06/mv_royal_nothe.png',
        'srcset': '/wp-content/uploads/2025/06/mv_royal_nothe.png 748w, /wp-content/uploads/2025/06/mv_royal_nothe.png 300w'
    });
}



	// reveal 

	var rafId = null;
	var delay = 200;
	var lTime = 0;

	function scroll() {
	  var scrollTop = $(window).scrollTop();
	  var height = $(window).height()
	  var visibleTop = scrollTop + height;
	  $('.reveal').each(function() {
	    var $t = $(this);
	    if ($t.hasClass('reveal_visible')) { return; }
	    var top = $t.offset().top;
	    if (top <= visibleTop) {
	      if (top + $t.height() < scrollTop) {
	        $t.removeClass('reveal_pending').addClass('reveal_visible');
	      } else {
	        $t.addClass('reveal_pending');
	        if (!rafId) requestAnimationFrame(reveal);  
	      }
	    }
	  });
	}
	function reveal() {
	  rafId = null;
	  var now = performance.now();
	  
	  if (now - lTime > delay) {
	    lTime = now;
	    var $ts = $('.reveal_pending');
	    $($ts.get(0)).removeClass('reveal_pending').addClass('reveal_visible');  
	  }
	  
	  
	  if ($('.reveal_pending').length >= 1) rafId = requestAnimationFrame(reveal);
	}


	$(scroll);
	$(window).scroll(scroll);



});



document.addEventListener('DOMContentLoaded', function () {
  const mobileTabs = document.querySelector('.mobile-tabs');
  if (!mobileTabs) return;

  const tabButtons = mobileTabs.querySelectorAll('.tab-btn');
  const tabContents = mobileTabs.querySelectorAll('.tab-content');

  tabButtons.forEach(button => {
    button.addEventListener('click', function () {
      const tabId = this.dataset.tab;

      // Show/hide tab contents
      tabContents.forEach(content => {
        content.style.display = content.id === tabId ? 'block' : 'none';
      });

      // Toggle active class on buttons
      tabButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("impact-stories")) {
        const buttons = document.querySelectorAll(".team-member-indiv .text.btn.btn-berry");
        buttons.forEach(button => {
            button.textContent = "Read More";
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
  const submenuContainer = document.querySelector(".giving-submenu-container");
  const menu = document.getElementById("menu-giving-menu");

  if (submenuContainer && menu) {
    const toggleBtn = document.createElement("button");
    toggleBtn.className = "submenu-toggle";
    toggleBtn.setAttribute("aria-expanded", "false");
    toggleBtn.innerHTML = `Giving Menu <span class="chevron"></span>`;

    submenuContainer.insertBefore(toggleBtn, menu);

    toggleBtn.addEventListener("click", function () {
      const expanded = toggleBtn.getAttribute("aria-expanded") === "true";
      toggleBtn.setAttribute("aria-expanded", String(!expanded));
      menu.classList.toggle("active");
      toggleBtn.classList.toggle("open"); // trigger chevron rotation
    });
  }
});

